<script setup lang="ts">
  import { computed } from "vue";
  import { useMonths } from "./utils";
  import { default as MoneymapFilterRangeModal } from "./MoneymapFilterRangeModal.vue";

  const { selected_range_id } = defineProps<{ selected_range_id: string }>();
  const emit = defineEmits<{ (e: "change", id: string): void }>();

  const months = useMonths();
  const list = computed(() => months.value.ids.map((id) => months.value.map[id]));
</script>

<template>
  <MoneymapFilterRangeModal :selected_range_id="selected_range_id" :items="list" @click:item="emit('change', $event)" />
</template>
